import { useState } from 'react';
import './LoginComponent.less';

import { InputBox } from '@imprivata-cloud/components';
import { Form } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useTranslation } from 'react-i18next';

import ContinueButton from '../continueButton/ContinueButton';

export type LoginProps = {
  onSubmit: (userEmail: string) => Promise<void>;
};

const LoginComponent = ({ onSubmit }: LoginProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const submitLogin = async () => {
    setIsLoading(true);
    try {
      const values = await form.validateFields();
      const trimmedEmail = (values?.userEmail || '').trim();
      await onSubmit(trimmedEmail);
      form.setFieldsValue({ userEmail: trimmedEmail });
    } finally {
      // Keep the button locked to prevent double click
      await new Promise(resolve => setTimeout(resolve, 2_000));
      setIsLoading(false);
    }
  };

  const handleFormChange = () => {
    const email = form.getFieldValue('userEmail');
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);
    const isReady = email && !hasErrors;
    setIsButtonDisabled(!isReady);
  };

  return (
    <div className={'login-form'}>
      <Form
        form={form}
        className={'login-form-items'}
        requiredMark={false}
        onFinish={submitLogin}
        onFieldsChange={handleFormChange}
      >
        <h1 className={'login-form-title'}>{t('tenant-lookup.login.title')}</h1>
        <FormItem
          name={'userEmail'}
          colon={false}
          className={'login-form-input'}
        >
          <InputBox
            size="large"
            data-testid="email-input"
            label={t('tenant-lookup.login.username')}
            autoFocus
            maxLength={150}
          />
        </FormItem>
        <ContinueButton
          label={t('commons.continue-button')}
          type="primary"
          block
          htmlType={'submit'}
          disabled={isLoading || isButtonDisabled}
        />
      </Form>
    </div>
  );
};

export { LoginComponent };
